<script>
import route from "@webapix/shop-js/src/ziggy/route"

export default {
    props: {
        scrollTopOffset: {
            type: Number,
            default: () => {
                return 150
            }
        },
        scrollDuration: {
            type: Number,
            default: () => {
                return 500
            }
        },
        components: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            currentStep: 1,
            activeComponents: this.components,
            urls: {
                'authentication': route('shop.checkout.show'),
                'shipping-mode': route('shop.checkout.shippingModes'),
                'payment-mode': route('shop.checkout.paymentModes'),
                'customer-data': route('shop.checkout.customerData'),
                'summary-step': route('shop.checkout.summary'),
            }
        }
    },

    computed: {
        currentComponentIndex() {
            return this.currentStep - 1
        },
        currentComponent() {
            return this.activeComponents[this.currentComponentIndex]
        },
    },

    created() {
        this.$bus.$on('update-active-components', (activeComponents) => this.activeComponents = activeComponents)
        this.$bus.$on('checkout-step-next', () => this.stepNext())
        this.$bus.$on('checkout-step-back', () => this.stepBack())
        this.$bus.$on('cart-modified', () => this.currentStep = 1)
        this.$bus.$on('checkout-error', () => this.$loading.hide())
    },

    watch: {
        currentStep() {
            window.history.replaceState({}, '', this.urls[this.currentComponent])
        }
    },

    methods: {
        stepNext() {
            this.$loading.hide()
            this.jumpTo(this.currentStep + 1)

            this.$bus.$emit('checkout-step-navigated', {
                from: this.activeComponents[this.currentComponentIndex - 1],
                to: this.currentComponent
            })
        },

        stepBack() {
            if (this.currentStep > 1 ) {
                this.jumpTo(this.currentStep - 1)

                this.$bus.$emit('checkout-step-navigated', {
                    from: this.activeComponents[this.currentComponentIndex + 1],
                    to: this.currentComponent
                })
            }
        },

        jumpTo(step) {
            this.currentStep = step
        },
    },

    render() {
        return this.$scopedSlots.default({
            currentStep: this.currentStep
        })
    }
}
</script>
